import { useEffect } from "react";
import { userIsAdminOrModeratorOfSpace } from "@/react/helpers/spaceHelpers";
import { useDynamicLayoutContext } from "@circle-react/components/Layout/DynamicLayout";
import { CommunityMembers } from "@circle-react/components/shared/MembersList/CommunityMembers";
import { ViewTypes } from "@circle-react/components/shared/MembersList/CommunityMembers/ListView/CommunityMember/MemberActions";
import { Filters } from "@circle-react/components/shared/MembersList/Filters";
import { SORT_OPTIONS } from "@circle-react/components/shared/MembersList/constants";
import type { Space } from "@circle-react/types";

interface SpaceMembersProps {
  space: Space;
}

export const SpaceMembers = ({ space }: SpaceMembersProps) => {
  const shouldShowAdminFilters = userIsAdminOrModeratorOfSpace(space);
  const { resetDynamicLayoutProps, setDynamicLayoutProps } =
    useDynamicLayoutContext();

  useEffect(() => {
    setDynamicLayoutProps({
      disableRightSidebar: true,
    });
    return resetDynamicLayoutProps;
  }, []);

  return (
    <>
      <Filters
        shouldShowSpacesFilter={false}
        shouldBeHiddenOnMd={false}
        shouldShowAdminFilters={shouldShowAdminFilters}
      />
      <CommunityMembers
        scopeResults={{ spaces: space.slug }}
        defaultSort={space.default_member_sort || SORT_OPTIONS[2]}
        viewType={ViewTypes.MEMBER_SPACES}
        space={space}
        shouldShowHiddenMemberTooltip={false}
      />
    </>
  );
};
